window.addEventListener('DOMContentLoaded', function() {

    // Object to store the variant IDs and their corresponding quantities
    var cartIds = {};

    // Event handler for adding products to the cart
    $(document).on("click", ".cart-product", function() {
        var cartDetails = $(this).attr('data-variant-id');
        if (!cartIds.hasOwnProperty(cartDetails)) {
            cartIds[cartDetails] = 0; // Initialize the quantity to 0 if it doesn't exist
        }
    });

    // Event handler for removing products from the cart
    $(document).on("click", ".remove-product", function() {
        $('.cart__items__row').each(function() {
            if ($(this).find("input[type=checkbox]").prop("checked")) {
                console.log("Checkbox is checked");
                $('.cart__items__row[data-variant-id="' + $(this).attr('data-variant-id') + '"]').remove();
            }
        });

        // Updating the cart using Ajax
        Object.values(cartIds).forEach(function(item) {
            console.log("cartIds", cartIds)
            jQuery.ajax({
                url: window.Shopify.routes.root + 'cart/update.js',
                type: 'post',
                dataType: 'json',
                data: {
                    updates: cartIds
                },
                success: function(response) {
                    console.log("response", response);
                    if (response?.item_count == 0) {
                        $(".cart--hidden").removeClass("cart--hidden");
                      $(".drawer__bottom").addClass("cart--hidden"); 
                      
                        $(".remove-select-product").hide();
                    }
                    var responseObj = response;
                    var finalPrice = Shopify.formatMoney(responseObj.total_price);
                    $('.checkout__button span[data-cart-final]').text(finalPrice);
                }
            });
        });
    });

    // Periodically update the cart count
    setInterval(function() {
        $.ajax({
            type: 'POST',
            url: '/cart.js',
            dataType: 'json',
            success: function(cart) {
                $('a.navlink--cart .cart-count').text(cart.item_count);
            },
        });
    }, 1000);
});
